export default {
      id: "croc-usage",
      viewBox: "0 0 100 26",
      url: "assets/" + "sprite.svg#croc-usage",
      toString: function () {
        return this.url;
      }
    }